import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './TimeCard.css';

const TimeCard = ({ title, value, status, percent, tooltip }) => {
  const statusClass = status ? `timeCard--${status}` : '';
  const percentLabel = Number.isFinite(percent) ? `${percent}%` : '--';

  return (
    <Box className={`timeCard ${statusClass}`.trim()}>
      <Box className="timeCard__titleRow">
        <Typography className="timeCard__title">{title}</Typography>
        {tooltip && (
          <Tooltip title={tooltip} arrow placement="top">
            <InfoOutlinedIcon className="timeCard__infoIcon" />
          </Tooltip>
        )}
      </Box>
      <Typography className="timeCard__percent">SLA: {percentLabel}</Typography>
      <Typography className="timeCard__value">{value}</Typography>
    </Box>
  );
};

export default TimeCard;
